import { Icon } from '@chakra-ui/react';

export default function SFEyeIcon(props) {
  return (
    <Icon
      w={6}
      h={6}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12 19.0625C5.76562 19.0625 1.32031 13.9609 1.32031 12.3672C1.32031 10.7656 5.77344 5.67188 12 5.67188C18.3047 5.67188 22.6719 10.7656 22.6719 12.3672C22.6719 13.9609 18.3125 19.0625 12 19.0625ZM12 17.8281C17.125 17.8281 21.3047 13.4688 21.3047 12.3672C21.3047 11.4375 17.125 6.90625 12 6.90625C6.85156 6.90625 2.6875 11.4375 2.6875 12.3672C2.6875 13.4688 6.85156 17.8281 12 17.8281ZM12 16.7422C9.55469 16.7422 7.60156 14.75 7.60156 12.3672C7.60156 9.92188 9.55469 7.99219 12 7.99219C14.4297 7.99219 16.3828 9.92188 16.3828 12.3672C16.3828 14.75 14.4297 16.7422 12 16.7422ZM12 13.8203C12.8047 13.8203 13.4609 13.1641 13.4609 12.3672C13.4609 11.5625 12.8047 10.9141 12 10.9141C11.1875 10.9141 10.5312 11.5625 10.5312 12.3672C10.5312 13.1641 11.1875 13.8203 12 13.8203Z'
        fill='currentColor'
      />
    </Icon>
  );
}
